import { render } from "./InventoryIndex.vue?vue&type=template&id=49867b9c"
import script from "./InventoryIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Inventory/InventoryIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49867b9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49867b9c', __exports__)) {
    api.reload('49867b9c', __exports__)
  }
  
  module.hot.accept("./InventoryIndex.vue?vue&type=template&id=49867b9c", () => {
    api.rerender('49867b9c', render)
  })

}


export default __exports__